import { Component, OnInit,Input , EventEmitter, Output  } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';


@Component({
  selector: 'app-modalcontent',
  templateUrl: './modalcontent.component.html',
  styleUrls: ['./modalcontent.component.css']
})
export class ModalcontentComponent implements OnInit {
    @Input() yourData: any;  
    @Output() dataSentBack = new EventEmitter<any>();
    
    imageChangedEvent: any = '';
    croppedImage: any = '';


    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

    sendDataBack() {
      // 發送資料回父組件
        this.dataSentBack.emit(this.croppedImage);
      
        this.closeModal();
    }

    closeModal() {
        this.activeModal.close();
    }

    // fileChangeEvent(event: any): void {
    //     console.log('event',event);
    //     this.imageChangedEvent = event;
    // }

    fileChangeEvent(event: any): void {
        const files = event.target.files;
    
        if (files.length > 0) {
            const file = files[0]; // 只选择第一个文件
    
            // 檢查文件是否是允許的圖片格式
            if (this.isImage(file)) {
                this.imageChangedEvent = event;
            } else {
                // 文件不是圖片，顯示錯誤信息
                alert('只允許上傳圖片格式！');
            }
        }
    }

    // 檢查文件是否是圖片類型
    isImage(file: File): boolean {
        const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
        return allowedImageTypes.includes(file.type);
    }

    imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
    }
    imageLoaded() {
      // show cropper
    }
    cropperReady() {

    }

    loadImageFailed() {
        // show message
    }

   
}




